"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var userGraph_exports = {};
__export(userGraph_exports, {
  UserWorkspaceGraph: () => UserWorkspaceGraph
});
module.exports = __toCommonJS(userGraph_exports);
var import_types = require("@cartographerio/types");
var import_util = require("@cartographerio/util");
var import_lodash = require("lodash");
var import_graph = require("./graph.js");
var import_memoize = require("./memoize.js");
class UserWorkspaceGraph extends import_graph.WorkspaceGraph {
  constructor(props) {
    super(props);
    this.allUsers = () => {
      return [...this.users];
    };
    this.optFindUserById = (0, import_memoize.memoize1)((id) => {
      return this.users.find((u) => u.id === id) ?? null;
    });
    this.findUserById = (id) => {
      return this.optFindUserById(id) ?? (0, import_util.raise)((0, import_types.notFoundError)("user", id));
    };
    this.findUsersByWorkspaceId = (0, import_memoize.memoize2)((id, name = "Active") => {
      const role = (0, import_types.workspaceRole)(name, id);
      return this.users.filter((user) => {
        const userRole = user.roles.find((r) => (0, import_types.roleWorkspaceId)(r) === id);
        return userRole != null && (0, import_types.roleGte)(userRole, role);
      });
    });
    this.findUsersByProjectId = (0, import_memoize.memoize2)((id, name = "Member") => {
      const role = (0, import_types.projectRole)(name, id);
      return this.users.filter((user) => {
        const userRole = user.roles.find((r) => (0, import_types.roleProjectId)(r) === id);
        return userRole != null && (0, import_types.roleGte)(userRole, role);
      });
    });
    this.findUsersByTeamId = (0, import_memoize.memoize2)((id, name = "Member") => {
      const role = (0, import_types.teamRole)(name, id);
      return this.users.filter((user) => {
        const userRole = user.roles.find((r) => (0, import_types.roleTeamId)(r) === id);
        return userRole != null && (0, import_types.roleGte)(userRole, role);
      });
    });
    this.stringify = () => {
      const ans = [];
      for (const ws of this.allWorkspaces()) {
        ans.push(`- workspace ${ws.id} / ${ws.alias}`);
        for (const p of this.findProjectsByWorkspaceId(ws.id)) {
          ans.push(`  - project ${p.id} / ${p.alias}`);
          for (const t of this.findTeamsByProjectId(p.id)) {
            ans.push(`    - team ${t.id} / ${t.alias}`);
          }
        }
        for (const u of this.findUsersByWorkspaceId(ws.id, "Disabled")) {
          ans.push(`  - user ${u.id} / ${u.screenName}`);
        }
      }
      return ans.join("\n");
    };
    this.users = (0, import_lodash.sortBy)(props.users, (u) => u.screenName);
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  UserWorkspaceGraph
});
//# sourceMappingURL=userGraph.js.map
